import gsap from 'gsap';

export default () => {

  const m = {}
  const isSp = window.matchMedia('(max-width: 767px)').matches;

  const init = () => {
    console.log('init mouseStorker');
    if (isSp) {
      return;
    }

    buildMouseStorker();
    bindHoverAction();
  }

  const buildMouseStorker = () => {
    m.mX = 0;
    m.mY = 0;
    m.pX = 0;
    m.pY = 0;
    m.delay = 10;

    m.storker = document.createElement('div');
    m.storker.classList.add('c-mouse-storker');
    m.storker.innerHTML = '<span class="c-mouse-storker__txt" data-txt=""></span>';
    m.storkerTxt = m.storker.firstElementChild;

    m.injectTarget = document.querySelector('.l-wrapper');

    m.injectTarget.before(m.storker);

    gsap.to(m.storker, {
      repeat: -1,
      duration: .01,
      ease: "power4.out",
      onRepeat: function() {
        m.pX += (m.mX - m.pX) / m.delay;
        m.pY += (m.mY - m.pY) / m.delay;

        gsap.set(m.storker, {
            css: {
              transform: `translate(${m.pX}px, ${m.pY}px)`
            }
        });
      }
    });

    window.addEventListener('mousemove', (e) => {
      m.mX = e.clientX;
      m.mY = e.clientY;
    });
  }

  const bindHoverAction = () => {
    const hoverTargetSelectors = [
      'js-hover-difference'
    ]
    const hoverTargets = document.querySelectorAll(`.${hoverTargetSelectors.join(', .')}`);
    console.log(hoverTargets);
    const selectorRegExp = new RegExp(`(${hoverTargetSelectors.join('|')})`);
    hoverTargets.forEach(target => {
      const hoverActionSelector = selectorRegExp.exec(target.className)[0].replace(/^js/, 'is');
      const storkerTxt = target.dataset.mouseTxt;
      const hoverActionModifiredSelector = `_${storkerTxt}`;
      target.addEventListener('mouseover', () => {
        m.storkerTxt.dataset.txt = storkerTxt;
        m.storker.classList.add(hoverActionSelector, hoverActionModifiredSelector);
      })
      target.addEventListener('mouseleave', () => {
        m.storkerTxt.dataset.txt = '';
        m.storker.classList.remove(hoverActionSelector, hoverActionModifiredSelector);
      })
    })
  }

  init();
  return {}
}
